const CONSENT_COOKIE_NAME = 'zgks-cookie-consent';
const CONSENT_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

function hasConsentCookie(): boolean {
    return document.cookie
        .split('; ')
        .some((entry) => entry === `${CONSENT_COOKIE_NAME}=1`);
}

function setConsentCookie(): void {
    document.cookie = `${CONSENT_COOKIE_NAME}=1; path=/; max-age=${CONSENT_COOKIE_MAX_AGE_SECONDS}; SameSite=Lax`;
}

// Runs synchronously before the banner markup is even parsed, so a returning visitor
// who already consented never sees it flash in before JS can hide it.
export function markCookieConsentState(): void {
    if (hasConsentCookie()) {
        document.documentElement.classList.add('cookie-consent-given');
    }
}

export function initCookieBanner(): void {
    const banner = document.getElementById('cookie-banner');
    const closeButton = banner?.querySelector<HTMLButtonElement>('.cookie-banner__close');
    if (!banner || !closeButton) return;

    closeButton.addEventListener('click', () => {
        setConsentCookie();
        banner.classList.add('is-dismissed');
    });
}
